"use client";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { useLayoutEffect } from "react";

const DynamicPostHogUserTracker = dynamic(() => import("./PostHogUserTracker"), {
  ssr: false,
});

const ClientWrapper = ({ children }) => {
  const pathname = usePathname();

  useLayoutEffect(() => {
    const scrollToTop = () => window.scrollTo({ top: 0, left: 0 });

    scrollToTop();
    const animationFrame = window.requestAnimationFrame(scrollToTop);

    return () => window.cancelAnimationFrame(animationFrame);
  }, [pathname]);

  return (
    <>
      <DynamicPostHogUserTracker />
      {children}
    </>
  );
};

export default ClientWrapper;
